import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography/Typography";

const styles = () => ({
  text: {
    whiteSpace: "pre-line",
  },
});

const ApiMessage = ({ classes, variant, message }) => {
  if (!message) {
    return null;
  }

  if (message.success) {
    return (
      <Typography className={classes.text} color="primary" variant={variant}>
        {message.success}
      </Typography>
    );
  }

  if (message.error) {
    return (
      <Typography className={classes.text} color="error" variant={variant}>
        {message.error}
      </Typography>
    );
  }
};
ApiMessage.propTypes = {
  classes: PropTypes.object.isRequired,
  variant: PropTypes.string,
  message: PropTypes.object.isRequired,
};
ApiMessage.defaultProps = {
  variant: "body2",
};

export default withStyles(styles)(ApiMessage);



// WEBPACK FOOTER //
// ./src/components/UI/ApiMessage.jsx